import resolveResponse from 'contentful-resolve-response'

import {clsx} from 'clsx'

import {ThemeProvider} from '@primer/react-brand'

import {useRoutePayload} from '@github-ui/react-core/use-route-payload'

import {ContentfulFaqGroup} from '@github-ui/swp-core/components/contentful/ContentfulFaqGroup'
import {ContentfulSubnav} from '@github-ui/swp-core/components/contentful/ContentfulSubnav'
import {FootnotesProvider} from '@github-ui/swp-core/components/contentful/FootnotesContext'

import {toPayload} from '../../../lib/types/payload'
import {toBrandPage} from '../../../brand/lib/types/contentful'

import {Footnotes} from './Footnotes/Footnotes'
import {Section} from './Section/Section'

import {PageProvider} from './PageContext'

import styles from './styles.module.css'

type Props = {
  children: React.ReactNode
  colorMode?: 'light' | 'dark'
  faqClassName?: string
  pageClassName?: string
  subnavClassName?: string
}

export function BrandPage(props: Props) {
  const {children, faqClassName, pageClassName, subnavClassName, colorMode} = props

  const {contentfulRawJsonResponse} = toPayload(useRoutePayload<unknown>())
  const contentfulResponse = resolveResponse(contentfulRawJsonResponse)
  const page = toBrandPage(contentfulResponse)

  const {template, settings} = page.fields
  const {subnav, faq} = template.fields

  return (
    <PageProvider page={page}>
      <FootnotesProvider>
        <ThemeProvider
          colorMode={settings?.fields.colorMode || colorMode || 'dark'}
          className={clsx(styles.page, pageClassName)}
        >
          {subnav ? <ContentfulSubnav component={subnav} className={clsx(styles.subnav, subnavClassName)} /> : null}

          {children}

          {faq ? (
            <Section id="faq" className={clsx(faqClassName)}>
              <ContentfulFaqGroup component={faq} />
            </Section>
          ) : null}

          <Footnotes />
        </ThemeProvider>
      </FootnotesProvider>
    </PageProvider>
  )
}
